import { LocalDate } from 'local-date';
import { SendStream } from '../components/util/SendStream';

export class MessageRequestDTO {

    customerids : number[]
    forDate : LocalDate
    sendStream : SendStream

    constructor(customerids : number[], forDate : LocalDate, sendStream : SendStream) {
        this.customerids = customerids
        this.forDate = forDate
        this.sendStream = sendStream
    }

}